const basePath = '/parcerias'

export default [
  // parcerias
  {
    path: `${basePath}`,
    name: 'partnership-list',
    component: () => import('@/views/pages/partnership/Partnership.vue'),
    meta: {
      pageTitle: 'Parcerias',
      navActiveLink: 'partnership-list',
      resource: 'Partnership',
      action: 'Read',
      breadcrumb: [
        {
          text: 'Vendas',
        },
        {
          text: 'Parcerias',
          active: true,
        },
      ],
    },
  },
]
